import styled from 'styled-components';

export const PersonalProfileWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
  `
);

export const GuestTxtWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-top:${props.theme.spacing.large.l15};
    padding-bottom:${props.theme.spacing.large.l15};
    padding-right:${props.theme.spacing.large.l20};
    padding-left:${props.theme.spacing.large.l20};
    justify-content:space-between;
  `
);

export const PricingTxtSpan = styled.span(
  props => `
    font-family:${props.theme.font.fontFamily};
    font-weight: bold;
    font-size:${props.theme.font.large.font18};
  `
);

export const ProfileDetailsEntryWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-top:${props.theme.spacing.large.l15};
    padding-bottom:${props.theme.spacing.large.l15};
    padding-right:${props.theme.spacing.large.l20};
    padding-left:${props.theme.spacing.large.l20};
  `
);

export const NameDetailsEntryWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding-right:${props.theme.spacing.large.l25};
    position:relative;
  `
);

export const TitleTxtWrapSpan = styled.span(
  props => `
    font-size:${props.theme.font.large.font14};
    color:${props.theme.colors.black.base};
  `
);

export const NameEnterInput = styled.input(
  props => `
    display: inline-flex;
    width:24.7rem;
    border: none;
    padding:${props.theme.spacing.base};
    font-size: ${props.theme.font.large.font14};
    border:${props.theme.misc.border.base} solid ${
      props.errorBorder ? props.theme.colors.red.base : props.theme.colors.grey.lineGrey
    };
    margin-top:${props.theme.spacing.base};
    color: ${props.theme.colors.black.base};
    border-radius:${props.theme.misc.borderRadius.base};
    height:3.2rem;
    ::placeholder {
      color: ${props.theme.colors.grey.grey50};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large.font14};
    }
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }

  `,
);

export const AddressNewEnterInput = styled.input(
  props => `
    display: inline-flex;
    width:59.4rem;
    border: none;
    padding:${props.theme.spacing.base};
    font-size: ${props.theme.font.large.font14};
    border:${props.theme.misc.border.base} solid ${
      props.errorBorder ? props.theme.colors.red.base : props.theme.colors.grey.lineGrey
    };
    margin-top:${props.theme.spacing.base};
    color: ${props.theme.colors.black.base};
    border-radius:${props.theme.misc.borderRadius.base};
    height:11.6rem;
    ::placeholder {
      color: ${props.theme.colors.grey.grey50};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large.font14};
    }
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);

export const MobileEnterInput = styled.input(
  props => `
    display: inline-flex;
    width:28.9rem;
    border: none;
    padding:${props.theme.spacing.base};
    font-size: ${props.theme.font.large.font14};
    border:${props.theme.misc.border.base} solid ${
      props.errorBorder ? props.theme.colors.red.base : props.theme.colors.grey.lineGrey
    };
    margin-top:${props.theme.spacing.base};
    color: ${props.theme.colors.black.base};
    border-radius:${props.theme.misc.borderRadius.base};
    height:3.2rem;
    ::placeholder {
      color: ${props.theme.colors.grey.grey50};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large.font14};
    }
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `
);

export const MobileInputOuterWrap = styled.div(
  props => `
    display:flex;
    justify-content:center;
    align-items:center;
  `
);

export const ErrorMessageDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-right:${props.theme.spacing.large.l20};
    padding-top:${props.theme.spacing.base};
    font-size:${props.theme.font.base};
    color:${props.theme.colors.red.base};
  `
);